import * as React from "react";
import {useState} from "react";
import "../styles.scss";
import {COLOR} from "utils/variables";

interface IListOfProducts {
    heading: string;
    identifier?: string;
    price: string;
    description?: string;
    icon?: string;
    routeName?: string;
    productCoverTypes?: string[];
    handleClick: (routePath: string, productName: string, coverType?: string) => void;
}

interface IProps {
    listOfProducts: IListOfProducts[];
}

const  ProductCard = (props: IProps) => {

    const [clicked, setClicked] = useState(false);
    const [productClicked, setProductClicked] = useState(0);

    const style = {
        fontSize: 14,
        boxShadow: `0px 3px 6px ${COLOR.SHADOW}`,
        padding: 10,
        display: clicked ? "flex" : "none",
        alignItems: "center",
        margin: 10,
    };
    const iconStyle = (index: number) =>{
        return {
            transform: clicked && index === productClicked ? "rotateZ(-90deg)" : "rotateZ(90deg)",
            transition: "all 0.2s ease"
        }
    }
    const labelStyle = {
        color: COLOR.GRAY
    }
    const priceStyle = {
        color: COLOR.PRIMARY,
        display: "inline",
        fontWeight: 600,
    }
    const onClickHandler = (index: number) => {
        if (index === productClicked) {
            setProductClicked(null);
            setClicked(false);
        } else {
            setClicked(true);
            setProductClicked(index);
        }
    }
 
    return (
        <div className="text-left">
            { props.listOfProducts.map((product, index) => {
                return (
                    <div className="product-card shadow" key={index}
                        onClick={() => onClickHandler(index)}>
                        <div className="d-flex flex-row align-items-center">
                            <div className="product-card-icon"><img src={product.icon} /></div>
                            <div className="pl-3">
                                <div className="product-heading mb-1">{product.heading}</div>
                                <div style={labelStyle}>Starting at: 
                                    <p style={priceStyle}>
                                        {
                                            Number(product.price) > 0 ? 
                                            <span>
                                                <i className="fa fa-inr price" aria-hidden="true"/> {product.price}
                                            </span> : " Free"
                                        }
                                    </p>
                                </div>
                            </div>
                            {<div className="ml-auto p-2"><i className="fa fa-angle-right" style={iconStyle(index)}/></div>}
                        </div>
                        <div className="cover-type">
                            {
                                productClicked === index &&  product.productCoverTypes.map((coverType, key) => {
                                    return (
                                        <div key={key} style={style} className="rounded bg-light text-center"
                                            onClick={() => product.handleClick(product.routeName, product.identifier, coverType)}>
                                            {coverType}
                                            {
                                                productClicked === index && clicked && 
                                                    <div className="ml-auto p-2">
                                                        <i className="fa fa-angle-right"/>
                                                    </div>
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default ProductCard;
